import InfoIcon from '@mui/icons-material/Info';
import { Box, Fade, Paper, Popper, PopperPlacementType } from '@mui/material';
import { PopperProps } from '@mui/material/Popper/Popper';
import { DEFAULT_THEME } from 'app/theme';
import React, { FC, ReactElement, useState } from 'react';
import { useStyles } from './Info.styles';

interface InfoProps extends Omit<PopperProps, 'open'> {
  iconSize?: number;
  control?: ReactElement;
  width?: number;
  placement?: PopperPlacementType;
}

const TIMER_DURATION = 500;

let hideTimeout: NodeJS.Timeout | string | number | undefined;

export const Info: FC<InfoProps> = ({
  children,
  control,
  iconSize = 16,
  width = 330,
  placement = 'top',
  ...rest
}) => {
  const { classes } = useStyles({ placement });
  const [popperAnchor, setPopperAnchor] = useState<SVGSVGElement | HTMLDivElement | null>(null);

  return (
    <>
      {control ? (
        <Box
          onMouseEnter={(event) => setPopperAnchor(event.currentTarget)}
          onMouseLeave={() => {
            clearTimeout(hideTimeout);
            hideTimeout = setTimeout(() => setPopperAnchor(null), 400);
          }}
        >
          {control}
        </Box>
      ) : (
        <InfoIcon
          sx={{ width: iconSize, height: iconSize, cursor: 'pointer' }}
          onMouseEnter={(event) => setPopperAnchor(event.currentTarget)}
          onMouseLeave={() => {
            clearTimeout(hideTimeout);
            hideTimeout = setTimeout(() => setPopperAnchor(null), TIMER_DURATION);
          }}
        />
      )}
      <Popper
        open={Boolean(popperAnchor)}
        anchorEl={popperAnchor}
        transition
        placement={placement}
        sx={{ zIndex: (DEFAULT_THEME.zIndex?.modal ?? 0) + 100 }}
        {...rest}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps}>
            <Paper
              sx={{ p: 2, width }}
              className={classes.text}
              onMouseEnter={() => clearTimeout(hideTimeout)}
              onMouseLeave={() => setPopperAnchor(null)}
            >
              {children}
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
};
